module.exports = __webpack_public_path__ + "media/images/costOfAbuse-graphic-lvl1-042ae0267f92792eaab97a17b4d591d1.svg";